import React from 'react';
import SafeIcon from '../common/SafeIcon';

export default function SettingsView() {
  return (
    <div className="max-w-3xl mx-auto space-y-8 pb-20">
      <header>
        <h1 className="text-3xl font-bold text-white">System Settings</h1>
        <p className="text-gray-400 font-mono text-sm">PREFERENCES // INFO</p>
      </header>

      <div className="glass-panel rounded-xl p-6 space-y-6">
        <h2 className="text-xl font-semibold text-white border-b border-graphite-700 pb-2">Interface</h2>
        
        <div className="flex items-center justify-between">
          <div>
            <p className="text-gray-200 font-medium">Dark Mode</p>
            <p className="text-sm text-gray-500">Enforce terminal aesthetics.</p>
          </div>
          <div className="w-12 h-6 bg-maker-cyan rounded-full flex items-center p-1 cursor-not-allowed opacity-80 glow-cyan">
            <div className="w-4 h-4 bg-graphite-900 rounded-full translate-x-6"></div>
          </div>
        </div>

        <div className="flex items-center justify-between">
          <div>
            <p className="text-gray-200 font-medium">Haptic Feedback</p>
            <p className="text-sm text-gray-500">Vibrate on task completion.</p>
          </div>
          <div className="w-12 h-6 bg-graphite-700 rounded-full flex items-center p-1 cursor-pointer">
            <div className="w-4 h-4 bg-gray-400 rounded-full"></div>
          </div>
        </div>
      </div>

      <div className="glass-panel rounded-xl p-6 space-y-6 border-maker-tan/30">
        <h2 className="text-xl font-semibold text-maker-tan border-b border-graphite-700 pb-2 flex items-center gap-2">
          <SafeIcon name="AlertCircle" className="w-5 h-5" />
          Danger Zone
        </h2>
        
        <div className="flex items-center justify-between">
          <div>
            <p className="text-gray-200 font-medium">Purge Database</p>
            <p className="text-sm text-gray-500">Erase all projects and inventory.</p>
          </div>
          <button className="px-4 py-2 bg-red-500/10 text-red-500 border border-red-500/50 rounded hover:bg-red-500 hover:text-white transition-colors text-sm font-mono">
            INITIATE_PURGE
          </button>
        </div>
      </div>

      <footer className="text-center pt-12 pb-4 text-sm text-gray-600 font-mono">
        <p>SYSTEM V.1.0.4 - ONLINE</p>
        <p className="mt-2 text-gray-500 tracking-widest">Made by LingLink AI and DigLab AI</p>
      </footer>
    </div>
  );
}